import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c9e3694"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16 ft18 boldFont"
}, "速记星超常儿童智力甄别和训练系统", -1));
const _hoisted_3 = {
  key: 0,
  class: "authoring-card"
};
const _hoisted_4 = {
  class: "authoring-step"
};
const _hoisted_5 = {
  class: "authoring-question-index"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "⚡", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "→", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "📷", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "→", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "✓", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "→", -1));
const _hoisted_12 = {
  key: 1,
  class: "authoring-rule-hint"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  class: "panel-heading"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "step-dot"
}, "1"), /*#__PURE__*/_createElementVNode("strong", null, "搭建机械臂")], -1));
const _hoisted_16 = ["disabled"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "hint"
}, "从底座开始依次执行。轴向旋转绕杆自身转动；法向旋转绕垂直于杆的轴转动。每个方向均可转 0°–180°。", -1));
const _hoisted_18 = {
  class: "joint-grid"
};
const _hoisted_19 = {
  class: "joint-number"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "type-switch"
};
const _hoisted_22 = ["disabled", "onClick"];
const _hoisted_23 = ["disabled", "onClick"];
const _hoisted_24 = {
  class: "angle-row"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["value", "onInput"];
const _hoisted_27 = ["onUpdate:modelValue", "onInput"];
const _hoisted_28 = {
  key: 2,
  class: "prediction"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prediction-title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "step-dot"
}, "2"), /*#__PURE__*/_createElementVNode("strong", null, "猜猜瓶盖朝向")], -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "hint option-hint"
}, "选出与右侧模型在初始视角下完全一致的水瓶姿态。", -1));
const _hoisted_31 = {
  class: "bottle-option-grid",
  "aria-label": "选择水瓶姿态"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["disabled"];
const _hoisted_34 = {
  class: "scene-topbar"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "live"
}, [/*#__PURE__*/_createElementVNode("i"), /*#__PURE__*/_createTextVNode(" 3D 实时预览")], -1));
const _hoisted_36 = {
  class: "view-tools"
};
const _hoisted_37 = {
  class: "orientation-card"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cap-icon"
}, "●", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "瓶盖当前朝向", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "view-reference-card"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "initial-view-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "view-cube"
}, "前"), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("small", null, "初始视角"), /*#__PURE__*/_createElementVNode("strong", null, "右前上方")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "legend"
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "red"
}), /*#__PURE__*/_createTextVNode("X 轴")]), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "green"
}), /*#__PURE__*/_createTextVNode("Y 轴")]), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "blue"
}), /*#__PURE__*/_createTextVNode("Z 轴")])])], -1));
const _hoisted_41 = {
  key: 1,
  class: "editor-preview editor-preview--initial editor-preview--below"
};
const _hoisted_42 = {
  class: "editor-preview__title"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "✓", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "题面图：调整前初始姿态", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "二次调整后不变 · 点击收起/展开", -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "initial-preview-note"
}, "这张图供学生观察初始姿态；调整后的机械臂看右侧实时预览，答案姿态看下方 8 个选项。", -1));
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  key: 2,
  open: "",
  class: "editor-preview editor-preview--final editor-preview--below"
};
const _hoisted_49 = {
  class: "editor-preview__title"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "✓", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "已暂存指令和 8 个选项", -1));
const _hoisted_52 = {
  class: "editor-command-summary"
};
const _hoisted_53 = {
  key: 0
};
const _hoisted_54 = {
  class: "bottle-option-grid editor-option-preview"
};
const _hoisted_55 = {
  class: "editor-answer-summary"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已生成 8 个水瓶姿态选项", -1));
const _hoisted_57 = {
  class: "answer-dialog__icon"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "机械臂姿态验证", -1));
const _hoisted_59 = {
  class: "answer-dialog__body"
};
const _hoisted_60 = {
  class: "answer-dialog__answer"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确姿态", -1));
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import api from '@/api';
import { ElMessage } from 'element-plus';
export default {
  __name: 'RobotArmBottleView',
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    tplId: {
      type: [Number, String],
      default: null
    },
    questionIndex: {
      type: Number,
      default: 0
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const route = useRoute();
    const canvasHost = ref(null);
    const joints = ref([]);
    const guess = ref('');
    const checked = ref(false);
    const sceneVersion = ref(0);
    const viewLocked = ref(false);
    const activeTplId = computed(() => props.tplId || route.query.tplId);
    const activeQuestionIndex = computed(() => props.tplId ? props.questionIndex : Number(route.query.questionIndex || 0));
    const randomAdjustmentCount = computed(() => Math.min(5, Math.floor(activeQuestionIndex.value / 6) + 1));
    const editorMode = computed(() => Boolean(activeTplId.value));
    const editorStage = ref('initial');
    const initialState = ref(null);
    const initialPreviewImage = ref('');
    const savedScenario = ref(null);
    const scenarioRevision = ref(0);
    const loadingScenario = ref(false);
    const loadedQuestionIndex = ref(null);
    let scenarioLoadVersion = 0;
    const adjustmentValues = ref([]);
    const activeAdjustmentCount = computed(() => adjustmentValues.value.filter(adjustment => adjustment.angle > 0).length);
    const horizontalGlyphs = {
      '-1,-1': '↙',
      '0,-1': '↓',
      '1,-1': '↘',
      '-1,0': '←',
      '0,0': '•',
      '1,0': '→',
      '-1,1': '↖',
      '0,1': '↑',
      '1,1': '↗'
    };
    const axisName = (axis, value) => value === 0 ? '' : `${value > 0 ? {
      x: '右',
      y: '上',
      z: '前'
    }[axis] : {
      x: '左',
      y: '下',
      z: '后'
    }[axis]}`;
    const choices = [-1, 0, 1].flatMap(y => [-1, 0, 1].flatMap(z => [-1, 0, 1].filter(x => x || y || z).map(x => ({
      x,
      y,
      z,
      value: `${x},${y},${z}`,
      glyph: horizontalGlyphs[`${x},${z}`],
      label: `${axisName('x', x)}${axisName('y', y)}${axisName('z', z)}方向`
    }))));
    const answerOptions = ref([]);
    const answerOptionId = ref('');
    const optionCanvases = new Map();
    const poseOffsets = [[0, 0, 0], [Math.PI / 2, 0, 0], [-Math.PI / 2, 0, 0], [0, Math.PI / 2, 0], [0, -Math.PI / 2, 0], [0, 0, Math.PI / 2], [0, 0, -Math.PI / 2], [0, Math.PI, 0]];
    let previousCorrectIndex = -1;
    let scene, camera, renderer, controls, armRoot, bottle, animationFrame, resizeObserver;
    let thumbnailRenderer, thumbnailScene, thumbnailCamera, thumbnailFrame;
    let jointRotations = [];
    let jointAnnotations = [];
    const newJoint = (type = 'normal', angle = 0, direction = 1) => ({
      id: `${Date.now()}-${Math.random()}`,
      type,
      angle,
      direction
    });
    const randomItem = items => items[Math.floor(Math.random() * items.length)];
    const capVectorFor = jointState => {
      const orientation = new THREE.Quaternion();
      jointState.forEach(joint => {
        const axis = joint.type === 'axial' ? new THREE.Vector3(0, 1, 0) : new THREE.Vector3(1, 0, 0);
        orientation.multiply(new THREE.Quaternion().setFromAxisAngle(axis, THREE.MathUtils.degToRad(joint.angle * joint.direction)));
      });
      return new THREE.Vector3(0, 1, 0).applyQuaternion(orientation);
    };
    const isFacingRight = jointState => {
      const direction = capVectorFor(jointState);
      return direction.x > .999 && Math.abs(direction.y) < .001 && Math.abs(direction.z) < .001;
    };
    const armStaysAboveBaseline = jointState => {
      const orientation = new THREE.Quaternion();
      const endpoint = new THREE.Vector3(0, 1.34, 0);
      const link = new THREE.Vector3(0, 1.55, 0);
      for (const joint of jointState) {
        const axis = joint.type === 'axial' ? new THREE.Vector3(0, 1, 0) : new THREE.Vector3(1, 0, 0);
        orientation.multiply(new THREE.Quaternion().setFromAxisAngle(axis, THREE.MathUtils.degToRad(joint.angle * joint.direction)));
        endpoint.add(link.clone().applyQuaternion(orientation));
        // 水平参考线位于底座顶部上方，任一连杆端点都不能落到该线以下。
        if (endpoint.y < .45) return false;
      }
      return true;
    };
    const randomInitialJoints = (minimumCount = 3) => {
      const angles = [0, 45, 90, 135, 180];
      // 仅选用瓶盖严格朝右的初始姿态，保证题面要求稳定成立。
      for (let attempt = 0; attempt < 2400; attempt += 1) {
        const candidate = Array.from({
          length: minimumCount + Math.floor(Math.random() * (6 - minimumCount))
        }, () => newJoint(randomItem(['axial', 'normal']), randomItem(angles), randomItem([-1, 1])));
        if (candidate.some(joint => joint.angle > 0) && isFacingRight(candidate) && armStaysAboveBaseline(candidate)) return candidate;
      }
      // 极少数采样未命中时，以一对已验证的旋转兜底，同时其余关节轴型仍保持随机。
      const count = minimumCount + Math.floor(Math.random() * (6 - minimumCount));
      const candidate = Array.from({
        length: count
      }, () => newJoint(randomItem(['axial', 'normal']), 0, randomItem([-1, 1])));
      const axialIndex = Math.floor(Math.random() * (count - 1));
      const normalIndex = axialIndex + 1 + Math.floor(Math.random() * (count - axialIndex - 1));
      candidate[axialIndex] = newJoint('axial', 90, 1);
      candidate[normalIndex] = newJoint('normal', 90, 1);
      return candidate;
    };
    function prepareAnswerOptions() {
      let correctIndex = Math.floor(Math.random() * poseOffsets.length);
      while (poseOffsets.length > 1 && correctIndex === previousCorrectIndex) correctIndex = Math.floor(Math.random() * poseOffsets.length);
      previousCorrectIndex = correctIndex;
      const distractors = poseOffsets.slice(1);
      let distractorIndex = 0;
      answerOptionId.value = `pose-${correctIndex}`;
      answerOptions.value = poseOffsets.map((offset, index) => ({
        id: `pose-${index}`,
        offset: index === correctIndex ? poseOffsets[0] : distractors[distractorIndex++]
      }));
    }
    const resetArm = () => {
      joints.value = [newJoint('axial', 45, -1), newJoint('normal', 45, -1), newJoint()];
      guess.value = '';
      checked.value = false;
      prepareAnswerOptions();
      buildArm();
    };
    const cloneJointState = source => source.map((joint, index) => ({
      jointId: index + 1,
      type: joint.type,
      angle: joint.angle,
      direction: joint.direction
    }));
    const armFrame = (viewCamera, aspect, fill = .82) => {
      if (!viewCamera || !controls || !armRoot) return null;
      armRoot.updateWorldMatrix(true, true);
      const direction = viewCamera.position.clone().sub(controls.target).normalize();
      const right = new THREE.Vector3().crossVectors(viewCamera.up, direction).normalize();
      const up = new THREE.Vector3().crossVectors(direction, right).normalize();
      const points = [];
      armRoot.traverse(node => {
        if (node.isSprite) {
          const center = node.getWorldPosition(new THREE.Vector3());
          const scale = node.getWorldScale(new THREE.Vector3());
          for (const x of [-1, 1]) for (const y of [-1, 1]) {
            points.push(center.clone().addScaledVector(right, x * scale.x / 2).addScaledVector(up, y * scale.y / 2));
          }
          return;
        }
        const geometry = node.geometry;
        if (!geometry) return;
        if (!geometry.boundingBox) geometry.computeBoundingBox();
        const bounds = geometry.boundingBox;
        if (!bounds || bounds.isEmpty()) return;
        for (const x of [bounds.min.x, bounds.max.x]) for (const y of [bounds.min.y, bounds.max.y]) for (const z of [bounds.min.z, bounds.max.z]) {
          points.push(new THREE.Vector3(x, y, z).applyMatrix4(node.matrixWorld));
        }
      });
      if (!points.length) return null;
      const range = axis => [Math.min(...points.map(point => point.dot(axis))), Math.max(...points.map(point => point.dot(axis)))];
      const [left, rightEdge] = range(right);
      const [bottom, top] = range(up);
      const [back, front] = range(direction);
      const center = right.clone().multiplyScalar((left + rightEdge) / 2).addScaledVector(up, (bottom + top) / 2).addScaledVector(direction, (back + front) / 2);
      const verticalTangent = Math.tan(THREE.MathUtils.degToRad(viewCamera.fov) / 2);
      const verticalLimit = verticalTangent * fill;
      const horizontalLimit = verticalLimit * aspect;
      let distance = 1;
      const fitDistance = () => Math.max(1, ...points.map(point => {
        const offset = point.clone().sub(center);
        return offset.dot(direction) + Math.max(Math.abs(offset.dot(right)) / horizontalLimit, Math.abs(offset.dot(up)) / verticalLimit);
      }));
      distance = fitDistance();
      // 近处的瓶子投影更大；按透视投影再校正中心，避免横向伸展时偏到画框一侧。
      for (let step = 0; step < 3; step += 1) {
        const projected = points.map(point => {
          const offset = point.clone().sub(center);
          const depth = distance - offset.dot(direction);
          return [offset.dot(right) / (depth * verticalTangent * aspect), offset.dot(up) / (depth * verticalTangent)];
        });
        const x = projected.map(point => point[0]);
        const y = projected.map(point => point[1]);
        center.addScaledVector(right, (Math.min(...x) + Math.max(...x)) / 2 * distance * verticalTangent * aspect).addScaledVector(up, (Math.min(...y) + Math.max(...y)) / 2 * distance * verticalTangent);
        distance = fitDistance();
      }
      return {
        center,
        direction,
        distance
      };
    };
    const fitArmInView = () => {
      const frame = armFrame(camera, camera?.aspect);
      if (!frame) return;
      const {
        center,
        direction,
        distance
      } = frame;
      controls.maxDistance = Math.max(18, distance * 1.5);
      controls.target.copy(center);
      camera.position.copy(center).addScaledVector(direction, Math.max(controls.minDistance, distance));
      camera.lookAt(center);
      controls.update();
      controls.saveState();
    };
    const captureInitialPreview = () => {
      if (!renderer?.domElement) return '';
      // 题面使用固定 4:3 画幅，根据机械臂实际几何体取景，不把现场预览的留白一起保存。
      const width = 1200;
      const height = 900;
      const captureCamera = camera.clone();
      captureCamera.aspect = width / height;
      const frame = armFrame(captureCamera, captureCamera.aspect, .84);
      if (!frame) return '';
      captureCamera.position.copy(frame.center).addScaledVector(frame.direction, frame.distance);
      captureCamera.lookAt(frame.center);
      captureCamera.updateProjectionMatrix();
      const originalSize = renderer.getSize(new THREE.Vector2());
      const originalRatio = renderer.getPixelRatio();
      try {
        renderer.setPixelRatio(1);
        renderer.setSize(width, height, false);
        renderer.render(scene, captureCamera);
        return renderer.domElement.toDataURL('image/png');
      } finally {
        renderer.setPixelRatio(originalRatio);
        renderer.setSize(originalSize.x, originalSize.y, false);
        renderer.render(scene, camera);
      }
    };
    const persistScenario = async scenario => {
      const saved = await api.saveMechanicalArmPoseScenario({
        tplId: Number(activeTplId.value),
        questionIndex: activeQuestionIndex.value,
        expectedRevision: scenarioRevision.value,
        scenario: {
          ...scenario,
          initialPreviewImage: initialPreviewImage.value,
          optionPreviewImage: captureOptionsImage()
        }
      });
      scenarioRevision.value = saved.revision;
      initialPreviewImage.value = saved.initialImageUrl;
    };
    const loadScenario = async () => {
      if (!editorMode.value) return;
      const requestVersion = ++scenarioLoadVersion;
      const questionIndex = activeQuestionIndex.value;
      loadingScenario.value = true;
      loadedQuestionIndex.value = null;
      savedScenario.value = null;
      try {
        const saved = await api.getMechanicalArmPoseScenario(Number(activeTplId.value), questionIndex);
        if (requestVersion !== scenarioLoadVersion) return;
        scenarioRevision.value = saved.revision || 0;
        loadedQuestionIndex.value = questionIndex;
        if (!saved.version) {
          initialState.value = null;
          initialPreviewImage.value = '';
          savedScenario.value = null;
          editorStage.value = 'initial';
          resetArm();
          return;
        }
        initialState.value = saved.initialState;
        initialPreviewImage.value = saved.initialImageUrl;
        adjustmentValues.value = saved.initialState.map((_, index) => {
          const command = saved.commands.find(item => item.jointId === index + 1);
          return {
            angle: command?.angleDeg || 0,
            direction: command?.direction === 'WITH_ARROW' ? -1 : 1
          };
        });
        editorStage.value = 'adjust';
        joints.value = saved.initialState.map(item => newJoint(item.type, item.angle, item.direction));
        await nextTick();
        buildArm();
        joints.value.forEach((_, index) => applyAdjustment(index));
        await nextTick();
        answerOptions.value = saved.options.map((option, index) => ({
          id: `pose-${index}`,
          offset: option.rotation
        }));
        answerOptionId.value = `pose-${saved.rightAnswer.charCodeAt(0) - 65}`;
        savedScenario.value = {
          ...saved,
          adjustments: saved.commands
        };
        await nextTick();
        renderBottleOptions();
      } catch (error) {
        if (requestVersion === scenarioLoadVersion) ElMessage.error('读取已保存题目失败');
      } finally {
        await nextTick();
        if (requestVersion === scenarioLoadVersion) loadingScenario.value = false;
      }
    };
    const lockInitialState = () => {
      initialState.value = cloneJointState(joints.value);
      initialPreviewImage.value = captureInitialPreview();
      adjustmentValues.value = initialState.value.map(() => ({
        angle: 0,
        direction: -1
      }));
      editorStage.value = 'adjust';
      guess.value = '';
      checked.value = false;
      ElMessage.success('初始状态已暂存，请继续设置二次调整');
    };
    const generateRandomQuestion = async () => {
      const commandCount = randomAdjustmentCount.value;
      joints.value = randomInitialJoints(Math.max(3, commandCount));
      buildArm();
      await nextTick();

      // 第一步保存的是右侧 3D 视图的真实截图，而不是由指令拼出的示意图。
      initialState.value = cloneJointState(joints.value);
      initialPreviewImage.value = captureInitialPreview();
      adjustmentValues.value = initialState.value.map(() => ({
        angle: 0,
        direction: -1
      }));
      editorStage.value = 'adjust';

      // 30 题分五档增加有效指令数，其余关节保持初始角度。
      // 水平线约束只用于初始状态；二次旋转不额外限制，确保题目变化充分。
      adjustmentValues.value = initialState.value.map((_, index) => ({
        angle: index < commandCount ? randomItem([30, 45, 60, 90]) : 0,
        direction: randomItem([-1, 1])
      }));
      joints.value.forEach((_, index) => applyAdjustment(index));
      await nextTick();
      prepareAnswerOptions();
      await nextTick();
      renderBottleOptions();
      saveScenario();
      ElMessage.success('已随机生成初始状态、二次指令和 8 个答案选项');
    };
    const adjustmentData = () => adjustmentValues.value.map((adjustment, index) => ({
      jointId: index + 1,
      direction: adjustment.direction === -1 ? 'WITH_ARROW' : 'AGAINST_ARROW',
      angleDeg: adjustment.angle
    })).filter(command => command.angleDeg > 0).map((command, index) => ({
      order: index + 1,
      ...command
    }));
    const saveScenario = () => {
      if (!initialState.value) {
        ElMessage.warning('请先锁定并保存初始状态');
        return false;
      }
      const adjustments = adjustmentData();
      if (!adjustments.length) {
        savedScenario.value = null;
        ElMessage.warning('请至少设置 1 个关节的二次调整角度，再暂存答案');
        return false;
      }
      const correctIndex = answerOptions.value.findIndex(option => option.id === answerOptionId.value);
      const scenario = {
        version: 'mechanical-arm-editor-v2',
        initialState: initialState.value,
        initialPreviewImage: initialPreviewImage.value,
        adjustments,
        options: answerOptions.value.map((option, index) => ({
          id: String.fromCharCode(65 + index),
          rotation: option.offset
        })),
        correctOptionId: String.fromCharCode(65 + correctIndex),
        rightAnswer: String.fromCharCode(65 + correctIndex)
      };
      savedScenario.value = scenario;
      ElMessage.success('第二步已暂存；点击“下一题”后将写入套题');
      return true;
    };
    const commitScenario = async () => {
      if (loadedQuestionIndex.value !== activeQuestionIndex.value) {
        ElMessage.warning('题目正在加载，请稍后保存');
        return false;
      }
      if (!savedScenario.value?.adjustments?.length) {
        ElMessage.warning('请至少调整 1 个关节，并点击“暂存二次调整并生成答案”');
        return false;
      }
      try {
        await persistScenario(savedScenario.value);
        ElMessage.success('题目已保存');
        return true;
      } catch (error) {
        ElMessage.error('题目保存失败，请稍后重试');
        return false;
      }
    };
    const addJoint = () => {
      if (joints.value.length < 6) {
        joints.value.push(newJoint());
        buildArm();
      }
    };
    const removeJoint = index => {
      joints.value.splice(index, 1);
      buildArm();
    };
    const applyAdjustment = index => {
      const initial = initialState.value[index];
      const adjustment = adjustmentValues.value[index];
      const signedAngle = initial.angle * initial.direction + adjustment.angle * adjustment.direction;
      joints.value[index].angle = Math.abs(signedAngle);
      joints.value[index].direction = signedAngle >= 0 ? 1 : -1;
      updateRotation(index);
    };
    const updateAdjustment = (index, event) => {
      adjustmentValues.value[index].angle = Number(event.target.value);
      applyAdjustment(index);
    };
    const flipAdjustment = index => {
      adjustmentValues.value[index].direction *= -1;
      applyAdjustment(index);
    };
    const updateRotation = index => {
      const node = jointRotations[index];
      const joint = joints.value[index];
      if (!node || !joint) return;
      paintJoint(index, joint);
      sceneVersion.value += 1;
      renderBottleOptions();
    };
    function paintJoint(index, joint) {
      const node = jointRotations[index];
      if (!node || !joint) return;
      node.rotation.set(0, 0, 0);
      node.rotation[joint.type === 'axial' ? 'y' : 'x'] = THREE.MathUtils.degToRad(joint.angle * joint.direction);
      updateAnnotation(index, joint);
    }
    function retakeInitialPreview() {
      if (!initialState.value || !renderer || !controls) return;
      const currentJoints = joints.value.map(joint => ({
        ...joint
      }));
      const cameraPosition = camera.position.clone();
      const cameraTarget = controls.target.clone();
      const savedPosition = controls.position0.clone();
      const savedTarget = controls.target0.clone();
      const savedZoom = controls.zoom0;
      const savedMaxDistance = controls.maxDistance;
      try {
        initialState.value.forEach((joint, index) => paintJoint(index, joint));
        initialPreviewImage.value = captureInitialPreview();
        if (savedScenario.value) savedScenario.value = {
          ...savedScenario.value,
          initialPreviewImage: initialPreviewImage.value
        };
        ElMessage.success('题面图已按当前观察角度重拍；进入下一题时保存');
      } finally {
        currentJoints.forEach((joint, index) => paintJoint(index, joint));
        controls.maxDistance = savedMaxDistance;
        camera.position.copy(cameraPosition);
        controls.target.copy(cameraTarget);
        controls.update();
        controls.position0.copy(savedPosition);
        controls.target0.copy(savedTarget);
        controls.zoom0 = savedZoom;
      }
    }
    const flipDirection = index => {
      joints.value[index].direction *= -1;
      updateRotation(index);
    };
    const setJointType = (index, type) => {
      joints.value[index].type = type;
      buildArm();
    };
    const resetView = () => controls?.reset();
    const toggleViewLock = () => {
      viewLocked.value = !viewLocked.value;
      if (!controls) return;
      // 锁定视角仍可缩放，便于观察细节；仅禁用拖拽带来的旋转与平移。
      controls.enableRotate = !viewLocked.value;
      controls.enablePan = !viewLocked.value;
      controls.enableZoom = true;
    };
    resetArm();
    const capVector = computed(() => {
      sceneVersion.value;
      if (!bottle) return new THREE.Vector3(0, 1, 0);
      return new THREE.Vector3(0, 1, 0).applyQuaternion(bottle.getWorldQuaternion(new THREE.Quaternion()));
    });
    const capDirection = computed(() => {
      const v = capVector.value;
      const axis = value => Math.abs(value) < .35 ? 0 : Math.sign(value);
      return `${axis(v.x)},${axis(v.y)},${axis(v.z)}`;
    });
    const directionName = computed(() => choices.find(item => item.value === capDirection.value)?.label || '上方');
    const directionArrow = computed(() => choices.find(item => item.value === capDirection.value)?.glyph || '↑');
    function material(color, metalness = .25) {
      return new THREE.MeshStandardMaterial({
        color,
        metalness,
        roughness: .32
      });
    }
    function mesh(geometry, color, position) {
      const item = new THREE.Mesh(geometry, material(color));
      item.position.copy(position);
      item.castShadow = true;
      item.receiveShadow = true;
      return item;
    }
    function setOptionCanvas(element, id) {
      const optionId = id.replace('preview-', '');
      if (!optionCanvases.has(optionId)) optionCanvases.set(optionId, new Set());
      const canvases = optionCanvases.get(optionId);
      if (element) canvases.add(element);else if (canvases) optionCanvases.delete(optionId);
      renderBottleOptions();
    }
    function setupThumbnailRenderer() {
      thumbnailScene = new THREE.Scene();
      thumbnailScene.background = new THREE.Color('#eef5ff');
      // 所有选项使用同一观察方向与缩放，便于比较瓶盖朝向。
      thumbnailCamera = new THREE.PerspectiveCamera(36, 600 / 414, .1, 100);
      thumbnailCamera.position.set(3.3, 1.65, 3.8);
      thumbnailCamera.lookAt(0, 0, 0);
      thumbnailScene.add(new THREE.HemisphereLight('#ffffff', '#8ba8cb', 2.8));
      const key = new THREE.DirectionalLight('#ffffff', 2.5);
      key.position.set(4, 7, 5);
      thumbnailScene.add(key);
      thumbnailRenderer = new THREE.WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: true
      });
      thumbnailRenderer.setPixelRatio(1);
      thumbnailRenderer.setSize(600, 414, false);
    }
    function renderOptionThumbnail(option, baseQuaternion) {
      const previewBottle = bottle.clone(true);
      previewBottle.position.set(0, 0, 0);
      previewBottle.quaternion.copy(baseQuaternion).premultiply(new THREE.Quaternion().setFromEuler(new THREE.Euler(...option.offset)));
      previewBottle.updateWorldMatrix(true, true);
      // 以旋转后的整体包围盒为中心摆放，避免倒置和横放时被画布裁切。
      previewBottle.position.sub(new THREE.Box3().setFromObject(previewBottle).getCenter(new THREE.Vector3()));
      thumbnailScene.add(previewBottle);
      thumbnailRenderer.render(thumbnailScene, thumbnailCamera);
      thumbnailScene.remove(previewBottle);
    }
    function captureOptionsImage() {
      if (!bottle || answerOptions.value.length !== 8) throw new Error('答案选项未生成');
      if (!thumbnailRenderer) setupThumbnailRenderer();
      bottle.updateWorldMatrix(true, false);
      const baseQuaternion = bottle.getWorldQuaternion(new THREE.Quaternion());
      const canvas = document.createElement('canvas');
      canvas.width = 1200;
      canvas.height = 600;
      const context = canvas.getContext('2d');
      context.fillStyle = '#eef5ff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      answerOptions.value.forEach((option, index) => {
        renderOptionThumbnail(option, baseQuaternion);
        context.drawImage(thumbnailRenderer.domElement, index % 4 * 300 + 10, Math.floor(index / 4) * 300 + 22, 280, 193);
      });
      return canvas.toDataURL('image/png');
    }
    function renderBottleOptions() {
      if (thumbnailFrame) return;
      thumbnailFrame = requestAnimationFrame(() => {
        thumbnailFrame = null;
        drawBottleOptions();
      });
    }
    function drawBottleOptions() {
      if (!bottle || !answerOptions.value.length || !optionCanvases.size) return;
      if (!thumbnailRenderer) setupThumbnailRenderer();
      bottle.updateWorldMatrix(true, false);
      const baseQuaternion = bottle.getWorldQuaternion(new THREE.Quaternion());
      answerOptions.value.forEach(option => {
        const canvases = optionCanvases.get(option.id);
        if (!canvases?.size) return;
        renderOptionThumbnail(option, baseQuaternion);
        canvases.forEach(canvas => {
          const context = canvas.getContext('2d');
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(thumbnailRenderer.domElement, 0, 0, canvas.width, canvas.height);
        });
      });
    }
    function clearArm() {
      if (armRoot) {
        armRoot.traverse(item => {
          item.geometry?.dispose();
          if (Array.isArray(item.material)) item.material.forEach(m => m.dispose());else item.material?.dispose();
        });
        scene.remove(armRoot);
      }
      jointRotations = [];
      jointAnnotations = [];
      armRoot = new THREE.Group();
      scene.add(armRoot);
    }
    function addRing(parent, radius, tube, color, rotation = [0, 0, 0], pos = new THREE.Vector3()) {
      const ring = mesh(new THREE.TorusGeometry(radius, tube, 12, 40), color, pos);
      ring.rotation.set(...rotation);
      parent.add(ring);
      return ring;
    }
    function addMechanicalJoint(parent, type) {
      const joint = new THREE.Group();
      parent.add(joint);
      const horizontal = type === 'normal';
      // 银灰色的轴承外圈：法向关节的转轴横向，轴向关节的转轴沿杆方向。
      const axisRotation = horizontal ? [0, 0, Math.PI / 2] : [0, 0, 0];
      const collar = mesh(new THREE.CylinderGeometry(.42, .42, .52, 32), '#c6d0dc', new THREE.Vector3());
      collar.rotation.set(...axisRotation);
      joint.add(collar);
      const inset = mesh(new THREE.CylinderGeometry(.31, .31, .55, 32), '#202d42', new THREE.Vector3());
      inset.rotation.set(...axisRotation);
      joint.add(inset);
      const ringRotation = horizontal ? [0, Math.PI / 2, 0] : [Math.PI / 2, 0, 0];
      addRing(joint, .43, .045, '#ff4e65', ringRotation);
      // 红线固定在转轴上，直观表示每个关节真正绕哪一根轴转动。
      const marker = mesh(new THREE.BoxGeometry(horizontal ? .11 : .09, horizontal ? .66 : .09, horizontal ? .09 : .66), '#ff4760', new THREE.Vector3());
      if (horizontal) marker.rotation.z = Math.PI / 2;
      joint.add(marker);
      const cyan = mesh(new THREE.CylinderGeometry(.27, .27, .02, 28), '#31d6e8', new THREE.Vector3());
      if (horizontal) cyan.rotation.z = Math.PI / 2;else cyan.rotation.x = Math.PI / 2;
      cyan.position[horizontal ? 'x' : 'y'] = .29;
      joint.add(cyan);
      return joint;
    }
    function createTextSprite(text, color = '#263b5e') {
      const canvas = document.createElement('canvas');
      canvas.width = 256;
      canvas.height = 96;
      const texture = new THREE.CanvasTexture(canvas);
      texture.minFilter = THREE.LinearFilter;
      const sprite = new THREE.Sprite(new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: false
      }));
      sprite.scale.set(.88, .33, 1);
      setSpriteText(sprite, text, color);
      return sprite;
    }
    function setSpriteText(sprite, text, color = '#263b5e') {
      const canvas = sprite.material.map.image;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(255,255,255,.92)';
      ctx.beginPath();
      ctx.roundRect(6, 8, 244, 80, 24);
      ctx.fill();
      ctx.fillStyle = color;
      ctx.font = '700 42px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, 128, 49);
      sprite.material.map.needsUpdate = true;
    }
    function addClockwiseArrow(parent, isAxial) {
      const arrowGroup = new THREE.Group();
      arrowGroup.rotation[isAxial ? 'x' : 'y'] = Math.PI / 2;
      parent.add(arrowGroup);
      const radius = .7;
      const start = Math.PI * .82;
      const end = -Math.PI * .72;
      const points = Array.from({
        length: 18
      }, (_, index) => {
        const angle = start + (end - start) * index / 17;
        return new THREE.Vector3(radius * Math.cos(angle), radius * Math.sin(angle), 0);
      });
      const curve = new THREE.CatmullRomCurve3(points);
      const arc = new THREE.Mesh(new THREE.TubeGeometry(curve, 34, .026, 8, false), new THREE.MeshBasicMaterial({
        color: '#ff4862'
      }));
      arrowGroup.add(arc);
      const x = radius * Math.cos(end);
      const y = radius * Math.sin(end);
      // 顺时针弧线终点的切线方向，箭头始终表达固定的顺时针参考方向。
      const tangent = new THREE.Vector3(Math.sin(end), -Math.cos(end), 0).normalize();
      arrowGroup.add(new THREE.ArrowHelper(tangent, new THREE.Vector3(x, y, 0), .38, 0xff4862, .14, .075));
    }
    function createAngleAnnotation(parent, joint, index) {
      const annotation = new THREE.Group();
      parent.add(annotation);
      const isAxial = joint.type === 'axial';
      // 扇形位于旋转平面中：轴向关节在 XZ 平面，法向关节在 YZ 平面。
      const sector = new THREE.Mesh(new THREE.BufferGeometry(), new THREE.MeshBasicMaterial({
        color: '#f6a623',
        transparent: true,
        opacity: .28,
        side: THREE.DoubleSide,
        depthWrite: false
      }));
      sector.rotation[isAxial ? 'x' : 'y'] = Math.PI / 2;
      sector.position[isAxial ? 'y' : 'x'] = .03;
      annotation.add(sector);
      const arc = new THREE.Line(new THREE.BufferGeometry(), new THREE.LineBasicMaterial({
        color: '#e59a14',
        transparent: true,
        opacity: .96
      }));
      arc.rotation.copy(sector.rotation);
      arc.position.copy(sector.position);
      annotation.add(arc);
      // 红色弧形箭头是固定的顺时针参考方向，不会随着该关节一起转动。
      addClockwiseArrow(annotation, isAxial);
      const angleLabel = createTextSprite(`${joint.angle}°`, '#be7400');
      annotation.add(angleLabel);
      const jointLabel = createTextSprite(`关节 ${index + 1}`);
      // 标签沿各自关节的参考坐标摆放，避开连杆与扇形。
      jointLabel.position.copy(isAxial ? new THREE.Vector3(-.98, .42, .12) : new THREE.Vector3(.12, .96, .72));
      annotation.add(jointLabel);
      jointAnnotations.push({
        sector,
        arc,
        angleLabel,
        joint
      });
    }
    function updateAnnotation(index, joint = joints.value[index]) {
      const annotation = jointAnnotations[index];
      if (!annotation || !joint) return;
      const radius = .92;
      const signed = THREE.MathUtils.degToRad(joint.angle) * joint.direction;
      const shape = new THREE.Shape();
      shape.moveTo(0, 0);
      shape.lineTo(radius, 0);
      const points = [new THREE.Vector3(radius, 0, 0)];
      const steps = Math.max(2, Math.ceil(Math.abs(joint.angle) / 6));
      for (let step = 1; step <= steps; step += 1) {
        const theta = signed * step / steps;
        const x = radius * Math.cos(theta);
        const y = radius * Math.sin(theta);
        shape.lineTo(x, y);
        points.push(new THREE.Vector3(x, y, 0));
      }
      shape.lineTo(0, 0);
      const nextGeometry = new THREE.ShapeGeometry(shape);
      annotation.sector.geometry.dispose();
      annotation.sector.geometry = nextGeometry;
      const arcGeometry = new THREE.BufferGeometry().setFromPoints(points);
      annotation.arc.geometry.dispose();
      annotation.arc.geometry = arcGeometry;
      const middle = signed / 2;
      const labelRadius = 1.18;
      if (joint.type === 'axial') annotation.angleLabel.position.set(labelRadius * Math.cos(middle), .06, labelRadius * Math.sin(middle));else annotation.angleLabel.position.set(.06, labelRadius * Math.cos(middle), labelRadius * Math.sin(middle));
      setSpriteText(annotation.angleLabel, `${joint.angle}°`, '#be7400');
    }
    function buildArm() {
      if (!scene) return;
      clearArm();
      const base = mesh(new THREE.CylinderGeometry(1.15, 1.38, .42, 48), '#26334a', new THREE.Vector3(0, .21, 0));
      armRoot.add(base);
      const baseRing = mesh(new THREE.TorusGeometry(.86, .07, 12, 40), '#45d8ff', new THREE.Vector3(0, .45, 0));
      baseRing.rotation.x = Math.PI / 2;
      armRoot.add(baseRing);
      armRoot.add(mesh(new THREE.CylinderGeometry(.3, .34, .72, 28), '#17253a', new THREE.Vector3(0, .79, 0)));
      const columnCollar = mesh(new THREE.CylinderGeometry(.43, .43, .16, 32), '#bfcad7', new THREE.Vector3(0, 1.16, 0));
      armRoot.add(columnCollar);
      const columnBand = mesh(new THREE.TorusGeometry(.37, .045, 10, 32), '#ff4e65', new THREE.Vector3(0, 1.23, 0));
      columnBand.rotation.x = Math.PI / 2;
      armRoot.add(columnBand);
      let pivot = new THREE.Group();
      pivot.position.y = 1.34;
      armRoot.add(pivot);
      joints.value.forEach((joint, index) => {
        createAngleAnnotation(pivot, joint, index);
        const rotation = new THREE.Group();
        pivot.add(rotation);
        jointRotations.push(rotation);
        addMechanicalJoint(rotation, joint.type);
        const length = 1.55;
        const rod = mesh(new THREE.CylinderGeometry(.18, .23, length, 20), '#17253a', new THREE.Vector3(0, length / 2, 0));
        rotation.add(rod);
        const highlight = mesh(new THREE.CylinderGeometry(.05, .05, length - .16, 16), '#2d455f', new THREE.Vector3(.14, length / 2, 0));
        rotation.add(highlight);
        const next = new THREE.Group();
        next.position.y = length;
        rotation.add(next);
        pivot = next;
        updateRotation(index);
      });
      bottle = new THREE.Group();
      bottle.position.y = .18;
      pivot.add(bottle);
      // 末端夹爪：U 形两指从两侧固定矿泉水瓶，瓶身不再直接连在机械臂上。
      const clampMaterial = '#121d2d';
      bottle.add(mesh(new THREE.BoxGeometry(.86, .15, .22), clampMaterial, new THREE.Vector3(0, .28, -.34)));
      bottle.add(mesh(new THREE.BoxGeometry(.14, .66, .24), clampMaterial, new THREE.Vector3(-.48, .58, -.18)));
      bottle.add(mesh(new THREE.BoxGeometry(.14, .66, .24), clampMaterial, new THREE.Vector3(.48, .58, -.18)));
      bottle.add(mesh(new THREE.BoxGeometry(.22, .13, .34), '#35445a', new THREE.Vector3(-.43, .83, 0)));
      bottle.add(mesh(new THREE.BoxGeometry(.22, .13, .34), '#35445a', new THREE.Vector3(.43, .83, 0)));
      bottle.add(mesh(new THREE.CylinderGeometry(.36, .42, 1.05, 32), '#a9eaf5', new THREE.Vector3(0, .52, 0)));
      bottle.add(mesh(new THREE.CylinderGeometry(.24, .24, .2, 32), '#a9eaf5', new THREE.Vector3(0, 1.12, 0)));
      bottle.add(mesh(new THREE.CylinderGeometry(.27, .27, .18, 32), '#ff5f68', new THREE.Vector3(0, 1.29, 0)));
      const capMarker = mesh(new THREE.ConeGeometry(.1, .25, 20), '#fff3b0', new THREE.Vector3(0, 1.5, 0));
      bottle.add(capMarker);
      if (editorMode.value) fitArmInView();
      sceneVersion.value += 1;
      nextTick(renderBottleOptions);
    }
    function setupScene() {
      scene = new THREE.Scene();
      scene.background = new THREE.Color('#eef5ff');
      // 初始画面略拉远，完整看到底座、关节和瓶子。
      camera = new THREE.PerspectiveCamera(38, 1, .1, 100);
      camera.position.set(8.1, 6.5, 9.6);
      renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      canvasHost.value.appendChild(renderer.domElement);
      controls = new OrbitControls(camera, renderer.domElement);
      controls.target.set(0, 3.4, 0);
      controls.enableDamping = true;
      controls.minDistance = 5;
      controls.maxDistance = 18;
      controls.enableRotate = !viewLocked.value;
      controls.enablePan = !viewLocked.value;
      controls.enableZoom = true;
      controls.saveState();
      scene.add(new THREE.HemisphereLight('#ffffff', '#7895bd', 2.6));
      const key = new THREE.DirectionalLight('#ffffff', 2.8);
      key.position.set(5, 9, 5);
      key.castShadow = true;
      scene.add(key);
      // 底部参考面保持浅蓝色，但用半透明材质避免遮住网格与机械臂底座。
      const ground = new THREE.Mesh(new THREE.CircleGeometry(7, 64), new THREE.MeshBasicMaterial({
        color: '#8ecdf4',
        transparent: true,
        opacity: .3,
        depthWrite: false,
        side: THREE.DoubleSide
      }));
      ground.rotation.x = -Math.PI / 2;
      ground.receiveShadow = true;
      scene.add(ground);
      const axes = new THREE.AxesHelper(1.55);
      axes.position.set(-3.4, .03, -2.7);
      scene.add(axes);
      buildArm();
      resizeObserver = new ResizeObserver(resize);
      resizeObserver.observe(canvasHost.value);
      resize();
      animate();
    }
    function resize() {
      const {
        clientWidth: width,
        clientHeight: height
      } = canvasHost.value;
      if (!width || !height) return;
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
      renderer.setSize(width, height);
    }
    function animate() {
      animationFrame = requestAnimationFrame(animate);
      controls.update();
      renderer.render(scene, camera);
    }
    watch(joints, () => {
      guess.value = '';
      checked.value = false;
      if (editorMode.value && editorStage.value === 'adjust' && !loadingScenario.value) savedScenario.value = null;
      prepareAnswerOptions();
      nextTick(renderBottleOptions);
    }, {
      deep: true
    });
    onMounted(async () => {
      await nextTick();
      setupScene();
      await loadScenario();
    });
    watch(activeQuestionIndex, () => {
      loadScenario();
    });
    onBeforeUnmount(() => {
      cancelAnimationFrame(animationFrame);
      if (thumbnailFrame) cancelAnimationFrame(thumbnailFrame);
      resizeObserver?.disconnect();
      controls?.dispose();
      renderer?.dispose();
      thumbnailRenderer?.dispose();
    });
    __expose({
      commitScenario
    });
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_container, {
        class: _normalizeClass(['TrainAnswerViewContainer', 'arm-practice', {
          'arm-practice--embedded': __props.embedded
        }]),
        direction: "vertical"
      }, {
        default: _withCtx(() => [!__props.embedded ? (_openBlock(), _createBlock(_component_el_header, {
          key: 0,
          class: "wd100 wbg flex items-center opd20 ptr arm-practice__header",
          height: "60px",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/'))
        }, {
          default: _withCtx(() => [_hoisted_1, _hoisted_2]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_container, {
          class: "arm-practice__layout"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            width: "420px",
            class: "control-panel"
          }, {
            default: _withCtx(() => [editorMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(editorStage.value === 'initial' ? '1' : '2'), 1), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(editorStage.value === 'initial' ? '配置机械臂初始状态' : '记录二次调整指令'), 1), _createElementVNode("small", _hoisted_5, "正在编辑：第 " + _toDisplayString(activeQuestionIndex.value + 1) + " 题", 1), _createElementVNode("p", null, _toDisplayString(editorStage.value === 'initial' ? '完成初始状态后锁定，再调整关节生成题目答案。' : '每个关节现在从 0° 开始，表示相对初始状态的二次旋转。'), 1)]), _createElementVNode("button", {
              class: "authoring-action authoring-action--random",
              onClick: generateRandomQuestion
            }, [_hoisted_6, _createTextVNode(" " + _toDisplayString(editorStage.value === 'initial' ? '随机生成整题' : '重新随机生成整题') + " ", 1), _hoisted_7]), editorStage.value === 'initial' ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "authoring-action authoring-action--lock",
              title: "拍摄初始姿态作为题面图，然后进入二次调整",
              onClick: lockInitialState
            }, [_hoisted_8, _createTextVNode(" 拍摄并锁定题面 "), _hoisted_9])) : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "authoring-action authoring-action--finish",
              onClick: saveScenario
            }, [_hoisted_10, _createTextVNode(" 暂存二次调整并生成答案 "), _hoisted_11]))])) : _createCommentVNode("", true), editorMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("strong", null, "本题建议调整 " + _toDisplayString(randomAdjustmentCount.value) + " 个关节", 1), editorStage.value === 'adjust' ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({
                'authoring-rule-hint--invalid': activeAdjustmentCount.value === 0
              })
            }, "当前已设置 " + _toDisplayString(activeAdjustmentCount.value) + " 个 · " + _toDisplayString(activeAdjustmentCount.value === 0 ? '至少设置 1 个才能保存' : '可手动修改'), 3)) : (_openBlock(), _createElementBlock("span", _hoisted_13, "生成后仍可手动修改"))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("button", {
              class: "add",
              disabled: joints.value.length >= 6 || editorMode.value && editorStage.value === 'adjust',
              onClick: addJoint
            }, "＋ 添加关节", 8, _hoisted_16)]), _hoisted_17, _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(joints.value, (joint, index) => {
              return _openBlock(), _createElementBlock("article", {
                key: joint.id,
                class: "joint-card"
              }, [_createElementVNode("header", null, [_createElementVNode("span", _hoisted_19, _toDisplayString(index + 1), 1), _createElementVNode("strong", null, "第 " + _toDisplayString(index + 1) + " 个关节", 1), joints.value.length > 1 && !(editorMode.value && editorStage.value === 'adjust') ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "remove",
                onClick: $event => removeJoint(index)
              }, "删除", 8, _hoisted_20)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("button", {
                class: _normalizeClass({
                  active: joint.type === 'axial'
                }),
                disabled: editorMode.value && editorStage.value === 'adjust',
                onClick: $event => setJointType(index, 'axial')
              }, "轴向旋转", 10, _hoisted_22), _createElementVNode("button", {
                class: _normalizeClass({
                  active: joint.type === 'normal'
                }),
                disabled: editorMode.value && editorStage.value === 'adjust',
                onClick: $event => setJointType(index, 'normal')
              }, "法向旋转", 10, _hoisted_23)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
                class: "direction",
                onClick: $event => editorMode.value && editorStage.value === 'adjust' ? flipAdjustment(index) : flipDirection(index)
              }, _toDisplayString(editorMode.value && editorStage.value === 'adjust' ? adjustmentValues.value[index]?.direction === 1 ? '↺ 逆箭头方向' : '↻ 顺箭头方向' : joint.direction === 1 ? '↺ 逆箭头方向' : '↻ 顺箭头方向'), 9, _hoisted_25), editorMode.value && editorStage.value === 'adjust' ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                value: adjustmentValues.value[index]?.angle || 0,
                type: "range",
                min: "0",
                max: "180",
                step: "1",
                "aria-label": "二次调整角度",
                onInput: $event => updateAdjustment(index, $event)
              }, null, 40, _hoisted_26)) : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": $event => joint.angle = $event,
                type: "range",
                min: "0",
                max: "180",
                step: "1",
                "aria-label": "旋转角度",
                onInput: $event => updateRotation(index)
              }, null, 40, _hoisted_27)), [[_vModelText, joint.angle, void 0, {
                number: true
              }]]), _createElementVNode("output", null, _toDisplayString(editorMode.value && editorStage.value === 'adjust' ? adjustmentValues.value[index]?.angle || 0 : joint.angle) + "°", 1)])]);
            }), 128))]), !editorMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _hoisted_30, _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerOptions.value, (option, index) => {
              return _openBlock(), _createElementBlock("button", {
                key: option.id,
                class: _normalizeClass({
                  selected: guess.value === option.id
                }),
                onClick: $event => guess.value = option.id
              }, [_createElementVNode("canvas", {
                ref_for: true,
                ref: element => setOptionCanvas(element, option.id),
                width: "600",
                height: "414"
              }, null, 512), _createElementVNode("span", null, _toDisplayString(index + 1), 1)], 10, _hoisted_32);
            }), 128))]), _createElementVNode("button", {
              class: "check",
              disabled: !guess.value,
              onClick: _cache[1] || (_cache[1] = $event => checked.value = true)
            }, "验证答案", 8, _hoisted_33)])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_main, {
            class: "scene-panel"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_createElementVNode("span", null, _toDisplayString(viewLocked.value ? '视角已锁定' : '拖动旋转视角 · 滚轮缩放'), 1), _createElementVNode("button", {
              class: "lock-view",
              onClick: toggleViewLock
            }, _toDisplayString(viewLocked.value ? '🔒 视角已锁定（点击解锁）' : '🔓 视角已解锁（点击锁定）'), 1), _createElementVNode("button", {
              onClick: resetView
            }, "↺ 回到初始视角")])]), _createElementVNode("div", {
              ref_key: "canvasHost",
              ref: canvasHost,
              class: "canvas-host"
            }, null, 512), _createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", null, [_hoisted_39, _createElementVNode("strong", null, [_createTextVNode(_toDisplayString(directionName.value) + " ", 1), _createElementVNode("em", null, _toDisplayString(directionArrow.value), 1)])])]), _hoisted_40]),
            _: 1
          })]),
          _: 1
        }), editorMode.value && initialState.value ? (_openBlock(), _createElementBlock("details", _hoisted_41, [_createElementVNode("summary", _hoisted_42, [_hoisted_43, _hoisted_44, _hoisted_45, _createElementVNode("button", {
          type: "button",
          class: "retake-question-image",
          onClick: _withModifiers(retakeInitialPreview, ["stop", "prevent"])
        }, "📷 重拍题面")]), _hoisted_46, initialPreviewImage.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "initial-state-preview-image",
          src: initialPreviewImage.value,
          alt: "调整前的机械臂初始姿态题面图"
        }, null, 8, _hoisted_47)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), editorMode.value && savedScenario.value && savedScenario.value.adjustments?.length ? (_openBlock(), _createElementBlock("details", _hoisted_48, [_createElementVNode("summary", _hoisted_49, [_hoisted_50, _hoisted_51, _createElementVNode("small", null, "正确答案：" + _toDisplayString(savedScenario.value.rightAnswer) + " · 点击收起/展开", 1)]), _createElementVNode("ol", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(savedScenario.value.adjustments, command => {
          return _openBlock(), _createElementBlock("li", {
            key: command.order
          }, "关节 " + _toDisplayString(command.jointId) + " " + _toDisplayString(command.direction === 'WITH_ARROW' ? '顺箭头方向' : '逆箭头方向') + "旋转 " + _toDisplayString(command.angleDeg) + "°", 1);
        }), 128)), !savedScenario.value.adjustments.length ? (_openBlock(), _createElementBlock("li", _hoisted_53, "无二次调整")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_54, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerOptions.value, (option, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: option.id,
            class: _normalizeClass({
              correct: String.fromCharCode(65 + index) === savedScenario.value.rightAnswer
            })
          }, [_createElementVNode("canvas", {
            ref_for: true,
            ref: element => setOptionCanvas(element, `preview-${option.id}`),
            width: "600",
            height: "414"
          }, null, 512), _createElementVNode("span", null, _toDisplayString(String.fromCharCode(65 + index)), 1)], 2);
        }), 128))]), _createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("strong", null, "正确答案：" + _toDisplayString(savedScenario.value.rightAnswer), 1)])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
          modelValue: checked.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => checked.value = $event),
          class: "answer-dialog",
          width: "400px",
          "align-center": "",
          "show-close": false
        }, {
          header: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(['answer-dialog__header', {
              correct: guess.value === answerOptionId.value
            }])
          }, [_createElementVNode("span", _hoisted_57, _toDisplayString(guess.value === answerOptionId.value ? '✓' : '?'), 1), _createElementVNode("div", null, [_hoisted_58, _createElementVNode("strong", null, _toDisplayString(guess.value === answerOptionId.value ? '回答正确' : '再观察一下'), 1)])], 2)]),
          footer: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            round: "",
            onClick: _cache[2] || (_cache[2] = $event => checked.value = false)
          }, {
            default: _withCtx(() => [_createTextVNode("继续练习")]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createElementVNode("p", null, _toDisplayString(guess.value === answerOptionId.value ? '你准确判断了水瓶在旋转后的姿态。' : '你的选择与模型结果不一致，试着观察每个关节旋转后带动的方向。'), 1), _createElementVNode("div", _hoisted_60, [_hoisted_61, _createElementVNode("strong", null, "选项 " + _toDisplayString(answerOptions.value.findIndex(option => option.id === answerOptionId.value) + 1), 1)])])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["class"]);
    };
  }
};